
// initial state
const state = {
  user: {},
  destination: {},
  initialized: false,
  logged: false,
  customFields: [],
  sheetCategories: {
    asc: 'Activité sportive et culturelle',
    deg: 'Dégustation',
    fma: 'Fête et manifestation',
    hlo: 'Hébergement locatif',
    hot: 'Hôtel',
    hpa: 'Hôtellerie de plein air',
    iti: 'Itinéraire',
    loi: 'Équipement de loisir',
    org: 'Organisme',
    pcu: 'Patrimoine culturel',
    pna: 'Patrimoine naturel',
    prd: 'Produit touristique',
    res: 'Restaurant',
    vil: 'Village de Vacances',
    region: 'Région',
    destination: 'Département',
    tourism_office: 'Office de tourisme',
    ot: 'Office de tourisme',
  },
  focusedObject: null,
  focusedParentDestinations: [],
  productCategories: [],
};

const mutations = {
  setProductCategories(currentState, productCategories) {
    currentState.productCategories = productCategories.values;
  },
  setFocusedObject(currentState, object) {
    currentState.focusedObject = object;
  },
  setFocusedParentDestinations(currentState, parents) {
    currentState.focusedParentDestinations = parents;
    currentState.focusedParentDestinations.unshift({
      id: 1,
      name: 'Raccourci',
    });
  },
  setDestination(currentState, destination) {
    currentState.destination = destination;
  },
  setInitialized(currentState, initialized) {
    currentState.initialized = initialized;
  },
  setUser(currentState, user) {
    currentState.user = user;
    currentState.logged = !!user && Object.keys(user).length !== 0;
  },
};

export { mutations, state };
